import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/useUserStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

export const useUser = () => {
  const userStore = useUserStore();
  const viewerItemStore = useViewerItemStore();
  const { id: userId, organizationIds: viewerOrgIds } = storeToRefs(userStore);
  const { userId: itemUserId, itemOrganization } = storeToRefs(viewerItemStore);

  const isCurrentItemOwner = computed(() => userId?.value === itemUserId.value);

  // True when the current viewer is logged in AND is a member of the item's
  // organization — owner, admin, member, or view-only. Checks against the
  // full list of memberships (not just the primary org) so users whose main
  // org differs from the item's org still get team-member affordances.
  // Anonymous viewers and cross-org viewers both evaluate false.
  const isSameOrgAsItem = computed(() => {
    const itemOrgId = itemOrganization.value?.id;
    if (!itemOrgId) {
      return false;
    }
    return viewerOrgIds.value.includes(itemOrgId);
  });

  return { isCurrentItemOwner, isSameOrgAsItem };
};
